import { apiGateway } from '../api';

async function getContrato(numeroContrato) {
    try {
        const response = await apiGateway.get(`/contrato/${numeroContrato}`);
        return response.data;
    } catch (error) {
        // console.error(error);
        return error;
    }
}

async function getEmpresas(numeroContrato) {
    try {
        const response = await apiGateway.get(`/contrato/${numeroContrato}/empresas`);
        return response.data;
    } catch (error) {
        // console.error(error);
        return error;
    }
}

async function getContratoResumo(numeroContrato) {
    try {
        const response = await apiGateway.get(`/contrato/${numeroContrato}/resumo`);
        return response.data;
    } catch (error) {
        // console.error(error);
        return error;
    }
}

async function getGrupoContratos(numContratoPrincipal) {
    try {
        const response = await apiGateway.get(`/grupo-contratos/${numContratoPrincipal}`);
        return response.data;
    } catch (error) {
        // console.error(error);
        return error;
    }
}

async function getContratosPorGrupo(codGrupoEmpresa) {
    try {
        const response = await apiGateway.get(`/contrato/grupo?codigoGrupoEmpresa=${codGrupoEmpresa}`);
        return response.data;
    } catch (error) {
        // console.error(error);
        return error;
    }
}

async function getInformacoesEmpresa(numContrato) {
    try {
        const response = await apiGateway.get(`/contrato/${numContrato}/empresa/informacoes`);
        return response.data;
    } catch (error) {
        // console.error(error);
        return error;
    }
}

async function getContratoPorEmailCpfCnpj(payload) {
    try {
        const response = await apiGateway.post('/contratos', payload);
        return response.data;
    } catch (error) {
        return error;
    }
}

async function getValoresPlanos(numContrato, codPlano, queryParams) {
    try {
        const response = await apiGateway.get(`/contratos/${numContrato}/planos/${codPlano}/valores`, {
            params: queryParams,
        });
        return response.data;
    } catch (error) {
        return error;
    }
}

async function getListaValoresPlanos(numContrato, codPlano, queryParams) {
    try {
        const response = await apiGateway.get(`/contratos/${numContrato}/planos/${codPlano}/valores/lista`, {
            params: queryParams,
        });
        return response.data;
    } catch (error) {
        return [];
    }
}

async function getRelatorioVidas(numContrato, queryParams) {
    apiGateway.defaults.timeout = 120000;
    try {
        const response = await apiGateway.get(`/contratos/${numContrato}/relatorios-de-vidas`, { params: queryParams });
        apiGateway.defaults.timeout = process.env.REACT_APP_API_TIMEOUT;
        return response.data;
    } catch (error) {
        apiGateway.defaults.timeout = process.env.REACT_APP_API_TIMEOUT;
        return error;
    }
}

async function getEnderecoCorrespondencia(numContrato) {
    try {
        const response = await apiGateway.get(`/contratos/${numContrato}/endereco/correspondencia`);
        return response.data;
    } catch (error) {
        return error;
    }
}

async function getEnderecoCobranca(numContrato) {
    try {
        const response = await apiGateway.get(`/contratos/${numContrato}/endereco/cobranca`);
        return response.data;
    } catch (error) {
        return error;
    }
}

export {
    getContrato,
    getEmpresas,
    getContratoResumo,
    getGrupoContratos,
    getContratosPorGrupo,
    getInformacoesEmpresa,
    getContratoPorEmailCpfCnpj,
    getValoresPlanos,
    getRelatorioVidas,
    getEnderecoCorrespondencia,
    getEnderecoCobranca,
    getListaValoresPlanos,
};
